module.exports = __webpack_public_path__ + "img/img3.93fe977b.png";